import routeTypeEnum from './routeTypeEnum';

import type { AgentSessionFragmentFragment } from '@/graphql/generated/graphql';
import userHasAtLeastOneRight from '@/util/rights/userHasAtLeastOneRight';

export enum verifyRouteResponse {
  allowed = 'allowed',
  /**
   * Redirect to dashboard
   */
  dashboard = 'dashboard',
  /**
   * Redirect to login
   */
  unauthorized = 'unauthorized',
  /**
   * Show message not authorized -> i.e: an admin try to see superadmin area
   */
  forbidden = 'forbidden',
}

export const isPublicRoute = (type: routeTypeEnum) => (type === routeTypeEnum.public);

export const verifyRoute = (
  rights?: string[] | string,
  layout?: routeTypeEnum,
  user?: AgentSessionFragmentFragment,
): verifyRouteResponse => {
  // Anyone has access to a public route
  if (layout === routeTypeEnum.public) {
    return verifyRouteResponse.allowed;
  }

  // If user is NOT logged
  if (!user) {
    if (layout === routeTypeEnum.session) {
      return verifyRouteResponse.allowed;
    }
    return verifyRouteResponse.unauthorized;
  }

  // If user is logged
  if (layout === routeTypeEnum.session) {
    return verifyRouteResponse.dashboard;
  }

  // Verify user right to visit this page
  if (user.permissions && rights) {
    const rightsArray = Array.isArray(rights) ? rights : [rights];
    if (!userHasAtLeastOneRight(rightsArray, user.permissions)) {
      return verifyRouteResponse.forbidden;
    }
  }

  return verifyRouteResponse.allowed;
};
